import request from '@/utils/request'

let CodeTemplateApi = {
  /*列表*/
   templateList(data, errorback) {
    return request._post('/shop/plus.codetemplate.codeTemplate/index', data, errorback);
  },
  /*添加*/
  addTemplate(data, errorback) {
    return request._post('/shop/plus.codetemplate.codeTemplate/add', data, errorback);
  },
  /*获取数据*/
  getTemplate(data, errorback) {
    return request._get('/shop/plus.codetemplate.codeTemplate/edit', data, errorback);
  },

  /*保存*/
  saveTemplate(data, errorback) {
    console.log(data)
    return request._post('/shop/plus.codetemplate.codeTemplate/edit', data, errorback);
  },
  /*删除*/
  delTemplate(data, errorback) {
    return request._post('/shop/plus.codetemplate.codeTemplate/delete', data, errorback);
  },

}
export default CodeTemplateApi;



// WEBPACK FOOTER //
// ./src/api/CodeTemplate.js